import React from 'react';
import './FormGrid.scss';

export interface FormGridProps {
  children: React.ReactNode;
  columns?: 1 | 2 | 3 | 4;
  className?: string;
}

export const FormGrid: React.FC<FormGridProps> = ({
  children,
  columns = 3,
  className = '',
}) => {
  return (
    <div className={`form-grid form-grid--${columns}-col ${className}`}>
      {children}
    </div>
  );
};

// Checkbox Group for multiple checkboxes
export interface CheckboxGroupProps {
  children: React.ReactNode;
  className?: string;
}

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  children,
  className = '',
}) => {
  return <div className={`checkbox-group ${className}`}>{children}</div>;
};

// Single Checkbox
export interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <label className={`checkbox-label ${disabled ? 'checkbox-label--disabled' : ''}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      {label}
    </label>
  );
};

